export const SimTypes = {
  simCardCode: 'SIM_CARD',
  simCardLabel: 'Klassische SIM-Karte',
  eSimCode: 'E_SIM',
  eSimLabel: 'eSIM'
}
